



















































import {Component, Prop, VModel, Vue} from 'vue-property-decorator';
import StringMask from '@pedrobslisboa/js-string-mask';
import CommonInputMixin from "@/components/new_style_components/mixins/CommonInputMixin.vue";

@Component<PortalInput>({
  inheritAttrs: false,
  mixins: [CommonInputMixin],
})
export default class PortalInput extends Vue {
  @VModel({ type: [String, Number] })
  private inputValue!: string;

  @Prop({ default: "text" })
  private type!: "text" | "number" | "email" | "password";

  @Prop({ default: null })
  private maxLength!: number | null;

  @Prop({ default: null })
  private callBack!: () => void | null;

  /**
   * Token -> Description
   * 0 -> Int
   * A -> Letter
   * S -> Letter or Int
   * * -> Any char
   * { -> Start escape group
   * } -> End escape group
   * [ -> Start recursive group
   * ] -> End recursive group
   * $ -> Escape next char
   */
  @Prop({ default: null })
  private mask!: string | null;

  @Prop({ default: undefined })
  private reverse?: boolean

  public created(): void {
    if (this.mask && this.internalValue) {
      this.internalValue = new StringMask({ mask: this.mask, reverse: this.reverse }).apply(this.internalValue.toString()).maskedValue;
    }
  }

	private processInput(target: any): void {
    this.trimValue()
		if (this.callBack) {
			this.callBack()
		}
		if (this.mask) {
			this.processMask(target);
		} else if (this.maxLength) {
			this.processMaxLength(target);
		}
	}

  private processMaxLength(target: any) {
    if (this.maxLength !== null && target.value.length >= this.maxLength) {
      target.value = target.value.substr(0, this.maxLength);
      this.$emit('input', target.value);
    }
  }

  private processMask(target: any) {
    const formatter = new StringMask({mask: this.mask as string, reverse: this.reverse});
    formatter.apply(target.value);
    target.value = formatter.maskedValue;
    this.$emit('input', formatter.maskedValue)
  }

  private trimValue(): void {
    if (this.type in ["text", "email"]) {
      this.internalValue = this.internalValue.trim();
    }
  }

  get internalValue(): string {
    return this.inputValue;
  }

  set internalValue(value: string) {
    this.$emit('input', value);
  }
}
